import { Configuration } from '../generated/configuration';

class AppConfiguration extends Configuration {
  override basePath = process.env.NX_API_BASE_URL;
}

export const appConfiguration = new AppConfiguration();

export const gqlBasePath = `${process.env.NX_API_BASE_URL}/graphql`;
